import { render, staticRenderFns } from "./locomotive-control-review.vue?vue&type=template&id=6398a598&scoped=true"
import script from "./locomotive-control-review.vue?vue&type=script&lang=js"
export * from "./locomotive-control-review.vue?vue&type=script&lang=js"
import style0 from "./locomotive-control-review.vue?vue&type=style&index=0&id=6398a598&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6398a598",
  null
  
)

export default component.exports